import styled from 'styled-components';

export const UnauthContainer = styled.div`
background: #F0FFE6;
width: 100%;
height: 100vh;
min-height: 800px;
`;

export const UnauthWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
height: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
margin-top: auto;
margin-bottom: auto;
padding: 0 25px;
justify-content: center;
align-items: center;
`;

export const UnauthImage = styled.img`
width: 100%;
max-width: 300px;
height: auto;
`;

export const UnauthHeader = styled.h1`
font-size: 36px;
color: #000;
text-align: center;
margin-top: 25px;

@media screen and (max-width: 768px){
    font-size: 24px;
}

@media screen and (max-width: 480px){
    font-size: 18px;
}
`;

export const UnauthText = styled.p`
font-size: 18px;
color: #000;
text-align: center;
margin-top: 25px;
margin-bottom: 25px;

@media screen and (max-width: 768px){
    font-size: 16px;
}

@media screen and (max-width: 480px){
    font-size: 14px;
}
`;
